/**
 * Sports SVG Icons Component
 * Renders SVG icons for sports based on sport ID
 * Matches the provided SVG designs
 */

import React from 'react';

const SportsSVGIcons = ({ sportId, size = '32px', className = '' }) => {
  const iconSize = size;

  const icons = {
    'popular': (
      <svg
        data-cy="ic-favourites-title"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        style={{ fill: 'currentcolor', color: 'rgb(255, 206, 0)', width: 'auto', height: iconSize }}
        className={className}
      >
        <defs>
          <style>
            {`.cls-1 { fill: #f11f5e; } .cls-2 { fill: #f7799e; }`}
          </style>
        </defs>
        <path
          className="cls-2"
          d="M9.54,25.82l6.15-4.19s.21-.2.59-.03,6.21,4.23,6.21,4.23l-1.98-6.95s-.22-.51.21-.81,5.49-4.66,5.49-4.66l-7.01-.23s-.51.06-.74-.55-2.39-6.45-2.39-6.45l-2.56,6.66s-.11.34-.65.37-7.06.26-7.06.26l5.44,4.53s.47.31.3.99-1.98,6.83-1.98,6.83Z"
        />
        <path
          className="cls-1"
          d="M20.72,18.07c.44-.3,5.49-4.66,5.49-4.66l-7.01-.23s-.51.06-.74-.55-2.39-6.45-2.39-6.45l-.48,1.26c.7,1.63,1.12,3.41,1.21,5.27.22,4.9-2.73,9.32-6.86,11.79-.23.77-.39,1.32-.39,1.32l6.15-4.19s.21-.2.59-.03c.38.16,6.21,4.23,6.21,4.23l-1.98-6.95s-.22-.51.21-.81Z"
        />
      </svg>
    ),
    'soccer': (
      <svg
        data-cy="sport-soccer"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M21.8203 10.5801V13.6101L23.8003 17.4601L25.8603 17.4301C25.8603 17.4301 25.9903 16.6801 25.9703 15.8101C25.9503 15.0001 25.7903 14.0801 25.6903 13.6301C25.6003 13.2401 25.3703 12.4801 25.0603 11.8301C24.7003 11.0701 24.3203 10.6201 24.3203 10.6201L21.8203 10.5801Z"
          fill="#F2EEFF"
        />
        <path
          d="M21.0331 14.7109L23.0531 18.1609L21.6831 21.7309L17.7131 22.8909L15.7031 18.8309L17.1631 15.5209L21.0331 14.7109Z"
          fill="#F2EEFF"
        />
        <path
          d="M13.6805 11.4609L16.2205 15.1809L14.7405 18.4609L10.9805 18.7009L8.98047 15.8109L10.4905 12.1209L13.6805 11.4609Z"
          fill="#F2EEFF"
        />
        <path
          d="M16.4705 7.41023L13.8905 10.4002L10.1405 11.1902L8.48047 9.32023C8.48047 9.32023 9.02047 8.71023 9.73047 8.15023C10.4905 7.55023 11.4605 7.00023 11.9705 6.78023C12.4005 6.59023 13.3105 6.30023 14.1205 6.15023C14.9305 6.00023 15.6705 5.99023 15.6705 5.99023L16.4605 7.43023L16.4705 7.41023Z"
          fill="#F2EEFF"
        />
        <path
          d="M8.17125 16.4495L10.1912 19.2495L9.90125 23.9695C9.90125 23.9695 9.05125 23.3295 8.27125 22.4295C7.73125 21.7995 7.24125 20.9295 7.02125 20.5295C6.85125 20.2095 6.56125 19.5695 6.38125 18.9395C6.13125 18.0695 6.03125 17.2095 6.03125 17.2095L8.17125 16.4395V16.4495Z"
          fill="#F2EEFF"
        />
        <path
          d="M14.8594 25.9795L17.7794 23.9195L21.9194 22.6895L22.9994 23.1995C22.9994 23.1995 22.2794 23.8995 21.4094 24.4895C20.7294 24.9395 19.9294 25.2795 19.5094 25.4295C18.9194 25.6395 17.6294 25.9195 16.5594 26.0095C15.6194 26.0895 14.8594 25.9795 14.8594 25.9795Z"
          fill="#F2EEFF"
        />
        <path
          d="M17.4084 6.93977L21.0684 9.23977L23.4284 9.33977C23.4284 9.33977 22.9184 8.73977 22.2284 8.17977C21.6184 7.67977 20.8384 7.22977 20.4484 7.02977C20.0784 6.83977 19.3584 6.51977 18.6384 6.32977C17.7484 6.08977 16.8984 6.00977 16.8984 6.00977L17.3984 6.92977L17.4084 6.93977Z"
          fill="#B4A6E2"
        />
        <path
          d="M21.8203 10.5801V13.6101L23.8003 17.4601L25.8603 17.4301C25.8603 17.4301 25.9903 16.6801 25.9703 15.8101C25.9503 15.0001 25.7903 14.0801 25.6903 13.6301C25.6003 13.2401 25.3703 12.4801 25.0603 11.8301C24.7003 11.0701 24.3203 10.6201 24.3203 10.6201L21.8203 10.5801Z"
          fill="#B4A6E2"
        />
        <path
          d="M23.0512 18.159L21.6812 21.729L17.7112 22.879L17.2812 22.019C18.5912 19.989 19.3812 17.609 19.4712 15.039L21.0413 14.709L23.0512 18.159Z"
          fill="#B4A6E2"
        />
        <path
          d="M14.8594 25.9795L17.7794 23.9195L21.9194 22.6895L22.9994 23.1995C22.9994 23.1995 22.2794 23.8995 21.4094 24.4895C20.7294 24.9395 19.9294 25.2795 19.5094 25.4295C18.9194 25.6395 17.6294 25.9195 16.5594 26.0095C15.6194 26.0895 14.8594 25.9795 14.8594 25.9795Z"
          fill="#B4A6E2"
        />
      </svg>
    ),
    'basketball': (
      <svg
        data-cy="sport-basketball"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M10.8881 15.5005H5.32812C5.41813 13.4905 6.06813 11.6305 7.12813 10.0605C9.19813 10.9005 10.7181 13.0005 10.8881 15.5005Z"
          fill="#FCD2DF"
        />
        <path
          d="M5.32812 16.5H10.8881C10.7081 18.99 9.18812 21.09 7.11812 21.93C6.06813 20.37 5.41813 18.5 5.32812 16.5Z"
          fill="#FCD2DF"
        />
        <path
          d="M7.76953 9.20008C9.62953 6.95008 12.3895 5.47008 15.4995 5.33008V15.5001H11.8595C11.6995 12.6701 10.0595 10.2701 7.76953 9.20008Z"
          fill="#FCD2DF"
        />
        <path
          d="M11.85 16.5H15.49V26.67C12.37 26.53 9.61 25.05 7.75 22.79C10.04 21.72 11.69 19.32 11.85 16.5Z"
          fill="#FCD2DF"
        />
        <path
          d="M24.34 22.67C22.47 25 19.66 26.52 16.5 26.67V16.5H20.48C20.64 19.22 22.18 21.55 24.34 22.67Z"
          fill="#FCD2DF"
        />
        <path
          d="M26.6597 16.5C26.5697 18.46 25.9497 20.28 24.9397 21.82C22.9997 20.91 21.5997 18.89 21.4297 16.5H26.6597Z"
          fill="#FCD2DF"
        />
        <path
          d="M20.4683 15.5001H16.4883V5.33008C19.6483 5.48008 22.4583 7.00008 24.3183 9.32008C22.1583 10.4401 20.6183 12.7701 20.4683 15.5001Z"
          fill="#FCD2DF"
        />
        <path
          d="M26.6597 15.4999H21.4297C21.5997 13.1099 22.9897 11.0799 24.9297 10.1699C25.9497 11.7099 26.5697 13.5399 26.6597 15.4999Z"
          fill="#FCD2DF"
        />
        <path
          d="M7.84172 22.7502C7.84172 22.7502 7.79172 22.7802 7.76172 22.7902C9.62172 25.0502 12.3817 26.5302 15.5017 26.6702V24.5402C14.9317 24.6402 14.3617 24.7002 13.7617 24.7002C11.5417 24.7002 9.50172 23.9702 7.84172 22.7402V22.7502Z"
          fill="#F7799D"
        />
        <path
          d="M16.5117 24.3098V26.6698C19.6717 26.5198 22.4817 24.9998 24.3517 22.6698C23.3917 22.1698 22.5617 21.4198 21.9117 20.5098C20.6117 22.3298 18.7217 23.6898 16.5117 24.3098Z"
          fill="#F7799D"
        />
        <path
          d="M22.4805 19.61C23.1005 20.57 23.9505 21.35 24.9605 21.82C25.9705 20.28 26.5905 18.46 26.6805 16.5H23.6105C23.4105 17.61 23.0205 18.66 22.4805 19.61Z"
          fill="#F7799D"
        />
        <path
          d="M22.803 10.4195C23.263 9.97945 23.783 9.60945 24.333 9.31945C22.683 7.25945 20.273 5.83945 17.543 5.43945C19.853 6.38945 21.733 8.16945 22.793 10.4195H22.803Z"
          fill="#F7799D"
        />
        <path
          d="M23.7309 15.4999H26.6709C26.5809 13.5399 25.9609 11.7099 24.9409 10.1699C24.2909 10.4699 23.7109 10.9099 23.2109 11.4399C23.5609 12.4599 23.7609 13.5599 23.7609 14.6999C23.7609 14.9699 23.7409 15.2399 23.7209 15.4999H23.7309Z"
          fill="#F7799D"
        />
      </svg>
    ),
    'tennis': (
      <svg
        data-cy="sport-tennis"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M22.9508 16.0008C22.9508 16.6908 22.8408 17.3508 22.6708 17.9908C22.1308 18.2408 21.2108 18.5808 19.7808 18.7408C19.5908 18.7708 19.3908 18.7908 19.1808 18.8008C16.9508 18.9608 14.0208 19.4408 13.8408 21.5608C13.8408 21.6408 13.8408 21.7208 13.8408 21.8008C13.8408 22.2908 13.9208 22.6908 14.0308 23.0208C12.5208 22.6608 11.2008 21.8208 10.2308 20.6808C9.34078 19.6408 8.74078 18.3508 8.55078 16.9308C9.12078 17.2808 9.86078 17.5308 10.6208 17.5308C11.0308 17.5308 11.4308 17.4608 11.8208 17.3008C13.4308 16.6408 14.0508 15.0108 14.7708 13.1208C14.9308 12.6908 15.1008 12.2408 15.2908 11.7908C16.0408 9.97078 17.0908 9.30078 17.8008 9.05078C19.0908 9.44078 20.2308 10.1708 21.1108 11.1508C22.2708 12.4308 22.9708 14.1308 22.9708 15.9908L22.9508 16.0008Z"
          fill="#56C400"
        />
        <path
          d="M22.2906 19C21.1506 21.5 18.6306 23.24 15.7106 23.24C15.4606 23.24 15.2106 23.22 14.9606 23.2C14.8106 22.9 14.6506 22.45 14.6406 21.8C14.6406 21.7 14.6406 21.61 14.6606 21.52C14.8606 20.49 16.2606 19.87 18.9106 19.64C19.0206 19.62 19.1306 19.62 19.2406 19.61C20.5206 19.52 21.5306 19.28 22.2906 19.01V19Z"
          fill="#56C400"
        />
        <path
          d="M16.5209 8.80047C15.8209 9.29047 15.0909 10.1205 14.5209 11.4905C14.3309 11.9505 14.1609 12.4105 13.9909 12.8405C13.3109 14.6205 12.7709 16.0305 11.4909 16.5505C10.5109 16.9505 9.30094 16.5805 8.61094 16.0105C8.55094 15.9605 8.50094 15.9105 8.46094 15.8605C8.52094 11.9205 11.7409 8.73047 15.7009 8.73047C15.9809 8.73047 16.2509 8.75047 16.5209 8.78047V8.80047Z"
          fill="#56C400"
        />
        <path
          d="M21.5495 13.8008C21.5495 15.6708 20.8895 17.4008 19.7695 18.7408C19.5795 18.7708 19.3795 18.7908 19.1695 18.8008C16.9395 18.9608 14.0095 19.4408 13.8295 21.5608H13.7795C12.4895 21.5608 11.2695 21.2408 10.1995 20.6808C9.30953 19.6408 8.70953 18.3508 8.51953 16.9308C9.08953 17.2808 9.82953 17.5308 10.5895 17.5308C10.9995 17.5308 11.3995 17.4608 11.7895 17.3008C13.3995 16.6408 14.0195 15.0108 14.7395 13.1208C14.8995 12.6908 15.0695 12.2408 15.2595 11.7908C16.0095 9.97078 17.0595 9.30078 17.7695 9.05078C19.0595 9.44078 20.1995 10.1708 21.0795 11.1508C21.3795 11.9808 21.5395 12.8608 21.5395 13.7908L21.5495 13.8008Z"
          fill="#8AFF2F"
        />
        <path
          d="M8.61875 16.0202C8.55875 15.9702 8.50875 15.9202 8.46875 15.8702C8.52875 11.9302 11.7487 8.74023 15.7087 8.74023C15.9887 8.74023 16.2588 8.76023 16.5288 8.79023C15.8288 9.28023 15.0987 10.1102 14.5287 11.4802C14.3387 11.9402 14.1687 12.4002 13.9987 12.8302C13.3187 14.6102 12.7787 16.0202 11.4987 16.5402C10.5187 16.9402 9.30875 16.5702 8.61875 16.0002V16.0202Z"
          fill="#8AFF2F"
        />
        <path
          d="M18.9102 19.6406C17.7502 20.6606 16.2802 21.3406 14.6602 21.5206C14.8602 20.4906 16.2602 19.8706 18.9102 19.6406Z"
          fill="#8AFF2F"
        />
      </svg>
    ),
    'table-tennis': (
      <svg
        data-cy="sport-tabletennis"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M16.7672 17.87L13.3672 19.99C13.8572 20.03 14.3572 19.99 14.8472 19.98C15.5772 19.95 16.4872 19.84 17.0872 20.3C17.6072 20.71 19.1172 23.81 19.4272 24.83C19.4872 25.04 19.6072 25.55 19.8972 25.56C20.3572 25.56 22.1072 24.45 22.2872 24.07C22.4072 23.81 22.0072 23.47 21.8472 23.32C21.0672 22.6 18.9472 19.87 18.8172 19.22C18.6672 18.48 19.1672 17.71 19.5172 17.07C19.7472 16.64 19.9972 16.21 20.1772 15.75L16.7772 17.87H16.7672Z"
          fill="#FF4B81"
        />
        <path
          d="M19.508 17.07C19.738 16.64 19.988 16.21 20.168 15.75L17.168 17.62L21.578 24.7C21.938 24.45 22.218 24.2 22.288 24.06C22.408 23.8 22.008 23.46 21.848 23.31C21.068 22.59 18.948 19.86 18.818 19.21C18.668 18.47 19.168 17.7 19.518 17.06L19.508 17.07Z"
          fill="#F7799E"
        />
        <path
          d="M11.9983 19.6701L20.4883 14.3801C20.4883 14.3801 20.4983 14.3001 20.5083 14.2601C20.6583 12.8001 19.9983 11.2601 19.2383 10.0501C18.7483 9.2701 17.8883 8.1801 16.8383 7.5201C15.7883 6.8601 14.8983 6.5701 14.1783 6.4801C11.6383 6.1601 8.52826 8.0901 7.68826 10.5201C7.45826 11.2001 7.31826 12.1301 7.44826 13.3601C7.57826 14.5901 8.17826 15.8501 8.66826 16.6301C9.42826 17.8401 10.5083 19.1201 11.8883 19.6301C11.9283 19.6401 11.9683 19.6501 11.9983 19.6701Z"
          fill="#FF4B81"
        />
        <path
          d="M18.8267 19.2796C18.5467 18.8396 18.4267 18.2896 18.3867 17.7696C18.3567 17.4696 18.3667 17.1496 18.4167 16.8496L16.7767 17.8696L15.1367 18.8896C15.4267 18.9796 15.7167 19.1096 15.9767 19.2696C16.4167 19.5396 16.8667 19.8796 17.1367 20.3296C17.6967 20.8596 19.1367 23.8196 19.4367 24.8196C19.4967 25.0296 19.6167 25.5396 19.9067 25.5496C20.1367 25.5496 20.6867 25.2796 21.1967 24.9596C21.7167 24.6396 22.1967 24.2696 22.2967 24.0596C22.4167 23.7996 22.0167 23.4596 21.8567 23.3096C21.0967 22.6096 19.0667 19.9996 18.8367 19.2696L18.8267 19.2796Z"
          fill="#FCD2DF"
        />
        <path
          d="M19.2392 10.0598C19.9892 11.2698 20.6592 12.8098 20.5092 14.2698C20.5092 14.3098 20.4892 14.3398 20.4892 14.3898L18.6292 15.5498C18.8492 13.3998 18.4092 11.2098 17.2092 9.29984C16.5292 8.21984 15.6692 7.30984 14.6992 6.58984C15.3092 6.73984 16.0292 7.01984 16.8392 7.52984C17.8992 8.18984 18.7492 9.27984 19.2392 10.0698V10.0598Z"
          fill="#F11F5E"
        />
        <path
          d="M20.1702 15.75C19.9902 16.2 19.7402 16.63 19.5102 17.07C19.1702 17.71 18.6502 18.48 18.8102 19.22C18.8102 19.22 18.8102 19.2267 18.8102 19.24C18.5402 18.8 18.4402 18.26 18.3802 17.76C18.3502 17.46 18.3602 17.15 18.4102 16.85L20.1702 15.76V15.75Z"
          fill="#F11F5E"
        />
        <path
          d="M22.7619 20.7894C23.7781 20.7894 24.6019 19.9656 24.6019 18.9494C24.6019 17.9332 23.7781 17.1094 22.7619 17.1094C21.7457 17.1094 20.9219 17.9332 20.9219 18.9494C20.9219 19.9656 21.7457 20.7894 22.7619 20.7894Z"
          fill="#FCD2DF"
        />
      </svg>
    ),
    'badminton': (
      <svg
        data-cy="sport-badminton"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M10.9517 17.4002L10.3417 16.6602L9.51172 18.3802L10.0917 18.9102L10.9517 17.4002Z"
          fill="#E4D8FD"
        />
        <path
          d="M13.5133 20.4396L13.2833 20.5596L12.4033 21.0196L11.8633 20.5296L12.1833 20.2096L12.8133 19.5996L13.5133 20.4396Z"
          fill="#E4D8FD"
        />
        <path
          d="M10.7109 19.4803L11.2509 19.9803L12.2809 18.9703L11.5209 18.0703L10.7109 19.4803Z"
          fill="#E4D8FD"
        />
        <path
          d="M14.653 21.8001L13.643 22.1601L13.043 21.6201L14.053 21.0901V21.0801L14.083 21.1001L14.653 21.8001Z"
          fill="#E4D8FD"
        />
        <path
          d="M25.2422 17.2304C24.9822 16.6204 24.3022 16.5404 24.3022 16.5404L19.5822 17.7004L23.0922 14.7504C23.0922 14.7504 23.7222 14.3104 23.3322 13.6804C22.9122 12.9904 22.3122 13.1904 22.3122 13.1904L19.1022 14.1504L20.5222 11.5804C20.5222 11.5804 21.0722 10.6504 20.1822 9.92035C19.2922 9.19035 18.5722 9.95035 18.5722 9.95035L16.2422 11.7804L17.2722 8.19035C17.2722 8.19035 17.6122 7.29035 16.5522 6.78035C15.3222 6.18035 14.8522 7.25035 14.8522 7.25035L10.7422 15.7804L11.4022 16.5604L12.9322 13.8604C13.0522 13.6504 13.3122 13.5604 13.5122 13.6704C13.7122 13.7804 13.7822 14.0304 13.6622 14.2404L11.9722 17.2304L12.8922 18.3304L16.0022 15.2704C16.1722 15.1004 16.4422 15.0904 16.6022 15.2604C16.7622 15.4204 16.7422 15.6904 16.5722 15.8604L13.4222 18.9604L14.3022 20.0004L17.5722 18.2804C17.7822 18.1704 18.0322 18.2404 18.1322 18.4504C18.2322 18.6604 18.1322 18.9204 17.9222 19.0304L14.8522 20.6404L15.5422 21.4604L24.8422 18.1504C24.8422 18.1504 25.4322 17.6603 25.2422 17.2104V17.2304Z"
          fill="#E4D8FD"
        />
        <path
          d="M8.91854 19.0288L8.29688 19.707L12.425 23.4911L13.0466 22.8129L8.91854 19.0288Z"
          fill="#F997B4"
        />
        <path
          d="M11.8803 24.1794C10.7503 25.4094 9.05026 25.7294 7.88026 24.9894C7.76026 24.9194 7.65026 24.8294 7.54026 24.7294C6.39026 23.6794 6.47026 21.7094 7.71026 20.3594L11.8803 24.1794Z"
          fill="#F997B4"
        />
        <path
          d="M9.98494 19.9995L9.36328 20.6777L12.4225 23.482L13.0442 22.8038L9.98494 19.9995Z"
          fill="#FF4B81"
        />
        <path
          d="M12.8094 19.5996L11.8594 20.5296L12.3994 21.0196L13.5094 20.4396L12.8094 19.5996Z"
          fill="#9789CD"
        />
        <path
          d="M12.2811 18.9595L11.2511 19.9795L11.1211 19.8595L12.1111 18.7695L12.2811 18.9595Z"
          fill="#9789CD"
        />
        <path
          d="M14.063 21.0801L13.043 21.6101L13.643 22.1601L14.663 21.8001L14.063 21.0801Z"
          fill="#9789CD"
        />
        <path
          d="M24.8505 18.1695L15.5505 21.4795L14.8605 20.6595L17.9305 19.0495C18.1405 18.9295 18.2405 18.6795 18.1505 18.4695C18.0605 18.2595 17.8005 18.1895 17.5905 18.2995L14.3205 20.0095L13.4405 18.9695L16.5905 15.8695C16.7705 15.6895 16.7805 15.4295 16.6205 15.2595C16.4605 15.0995 16.2005 15.0995 16.0205 15.2795L12.9205 18.3395L12.7305 18.1095L20.2205 9.93945C21.0905 10.6595 20.5505 11.5795 20.5505 11.5795L19.1305 14.1495L22.3405 13.1795C22.3405 13.1795 22.9405 12.9795 23.3605 13.6695C23.7505 14.3095 23.1205 14.7395 23.1205 14.7395L19.6105 17.6995L24.3305 16.5295C24.3305 16.5295 25.0105 16.6095 25.2705 17.2295C25.4505 17.6795 24.8705 18.1695 24.8705 18.1695H24.8505Z"
          fill="#9789CD"
        />
        <path
          d="M8.81961 21.3809L11.8696 24.1809C10.7396 25.4109 9.03961 25.7309 7.86961 24.9909C7.55961 23.7809 7.84961 22.4409 8.76961 21.4309L8.81961 21.3809Z"
          fill="#FF4B81"
        />
      </svg>
    ),
    'handball': (
      <svg
        data-cy="sport-handball"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <mask id="mask0_4051_11695" maskUnits="userSpaceOnUse" x="3" y="7" width="21" height="22" style={{ maskType: 'luminance' }}>
          <path
            d="M8.30813 7.42969L10.3881 8.13969C10.3881 8.13969 10.2581 9.39969 11.2881 10.2097C10.8181 10.6697 10.6081 11.7297 10.9581 12.4197C11.3081 13.1097 12.0681 13.9897 13.4581 14.6797C14.8481 15.3697 16.1281 15.7997 16.8981 16.2497C14.5781 15.9697 13.5681 16.3897 12.9681 17.6697C12.3681 18.9497 13.4281 20.0697 15.3181 20.7797C17.5281 21.6097 19.9581 22.2797 23.7681 21.4897C23.7481 21.9797 21.4981 25.4997 21.4981 25.4997L17.8581 28.0697L14.3081 27.8697L4.13812 20.9697L3.32812 17.1397L4.13812 12.7097L5.70813 9.69969L8.32812 7.42969H8.30813Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_4051_11695)">
          <path
            d="M15.8883 24.8898C20.9417 24.8898 25.0383 20.7932 25.0383 15.7398C25.0383 10.6864 20.9417 6.58984 15.8883 6.58984C10.8349 6.58984 6.73828 10.6864 6.73828 15.7398C6.73828 20.7932 10.8349 24.8898 15.8883 24.8898Z"
            fill="#F997B4"
          />
          <mask id="mask1_4051_11695" maskUnits="userSpaceOnUse" x="5" y="2" width="17" height="25" style={{ maskType: 'luminance' }}>
            <path
              d="M6.62953 9.79922C6.62953 9.79922 11.4995 10.2892 13.1995 15.0492C14.8995 19.8092 11.7195 22.8792 9.91953 24.7692C8.04953 26.6292 8.40953 26.4292 8.86953 26.8592C9.32953 27.2892 14.3995 24.1392 16.3995 22.4492C18.3995 20.7592 27.9795 11.2392 12.5395 2.69922C5.83953 5.56922 5.76953 8.03922 5.76953 8.03922L6.63953 9.80922L6.62953 9.79922Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_4051_11695)">
            <path
              d="M15.8883 24.8898C20.9417 24.8898 25.0383 20.7932 25.0383 15.7398C25.0383 10.6864 20.9417 6.58984 15.8883 6.58984C10.8349 6.58984 6.73828 10.6864 6.73828 15.7398C6.73828 20.7932 10.8349 24.8898 15.8883 24.8898Z"
              fill="#FF4B81"
            />
          </g>
        </g>
        <path
          d="M28.5806 13.3901C27.7006 8.72009 21.0706 5.03008 18.9906 4.15008C17.5306 3.53008 17.1106 4.42008 16.9806 5.00008C18.4206 5.66008 19.9806 6.50008 21.3006 7.50008C21.5206 7.67008 21.5606 7.98008 21.4006 8.20008C21.3006 8.33008 21.1506 8.40008 21.0006 8.40008C20.8906 8.40008 20.7906 8.37009 20.7006 8.30009C18.4406 6.59009 15.3506 5.34008 13.6106 4.71008C13.2606 4.81008 12.9806 4.99008 12.8506 5.30008C12.5906 5.80008 12.6506 6.19008 12.8406 6.49008C14.6306 7.22008 17.1906 8.36008 19.3406 9.70008C19.5706 9.85008 19.6506 10.1501 19.5006 10.3901C19.4106 10.5401 19.2406 10.6301 19.0806 10.6301C18.9906 10.6301 18.9006 10.6101 18.8206 10.5501C16.5506 9.14009 13.7406 7.92008 11.9806 7.22008C11.6306 7.32008 11.3506 7.55008 11.2406 8.03008C11.1706 8.54008 11.3706 8.98008 11.6506 9.34009C13.4406 10.0501 15.8106 11.0501 17.8406 12.1301C18.0806 12.2601 18.1806 12.5601 18.0506 12.8101C17.9606 12.9801 17.7906 13.0801 17.6106 13.0801C17.5306 13.0801 17.4506 13.0601 17.3806 13.0201C15.7406 12.1501 13.8706 11.3301 12.2806 10.6701C12.0606 10.8801 11.8506 11.1601 11.8106 11.4601C11.5406 13.1001 15.8506 14.7201 15.8506 14.7201C15.8506 14.7201 19.4206 16.0701 19.2506 16.9901C19.0806 17.9101 16.4606 16.5101 14.8006 17.2301C12.9806 18.1401 13.5806 19.4501 16.7006 20.3001C21.4206 21.8701 25.2606 20.1301 25.2606 20.1301C25.2606 20.1301 29.4206 18.0501 28.5906 13.3801L28.5806 13.3901Z"
          fill="#FFFC88"
        />
      </svg>
    ),
    'cricket': (
      <svg
        data-cy="sport-cricket"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M11.3609 16.9505L18.0609 6.40049C18.9009 5.07049 20.7509 4.72049 22.1709 5.62049L22.4409 5.79049C23.8609 6.69049 24.3309 8.51049 23.4809 9.84049L16.7809 20.3905C16.4009 20.9805 10.9609 17.5705 11.3609 16.9505Z"
          fill="#FFEA2F"
        />
        <path
          d="M21.4597 10.6398C23.1197 8.16977 23.2297 6.50977 23.2297 6.50977C23.2297 6.50977 23.2897 6.58977 23.3197 6.61977C24.0097 7.56977 24.1197 8.84977 23.4897 9.83977L16.7897 20.3898C16.6397 20.6298 15.6597 20.2198 14.5797 19.5998C14.5297 19.5698 14.4297 19.5098 14.4297 19.5098C14.4297 19.5098 15.3397 19.5398 16.1697 18.4898C17.7097 16.5298 21.4697 10.6398 21.4697 10.6398H21.4597Z"
          fill="#FFCE27"
        />
        <path
          d="M14.0759 20.6109L12.4805 19.5977L10.0411 23.4385L11.6365 24.4518L14.0759 20.6109Z"
          fill="#FFCE27"
        />
        <path
          d="M11.1801 25.5277L9.23013 24.2893C8.88514 24.0702 8.42905 24.1704 8.21142 24.513C7.99379 24.8557 8.09704 25.3111 8.44203 25.5302L10.392 26.7686C10.737 26.9877 11.1931 26.8876 11.4107 26.5449C11.6283 26.2023 11.5251 25.7469 11.1801 25.5277Z"
          fill="#FFCE27"
        />
        <path
          d="M20.8206 25.0508C20.1506 26.1108 18.7506 26.4208 17.6906 25.7508C17.0606 25.3508 16.6906 24.6908 16.6406 24.0008V23.9708C16.6406 23.9708 17.7906 23.9408 18.7106 24.1108C20.1106 24.3708 20.9506 24.8108 20.9506 24.8108C20.9506 24.8108 20.9506 24.8208 20.9406 24.8308C20.9006 24.9008 20.8706 24.9708 20.8206 25.0408V25.0508Z"
          fill="#F7799E"
        />
        <path
          d="M19.1494 23.06C17.9194 22.84 16.8594 22.85 16.8594 22.85C16.8594 22.85 16.8594 22.84 16.8594 22.83C16.8994 22.76 16.9394 22.69 16.9794 22.61C17.6494 21.55 19.0494 21.24 20.1094 21.91C20.7394 22.31 21.0994 22.96 21.1594 23.64C21.1594 23.65 21.1594 23.67 21.1594 23.67C21.1594 23.67 20.8394 23.52 20.4094 23.38C19.9794 23.24 19.4894 23.1 19.1394 23.04L19.1494 23.06Z"
          fill="#F7799E"
        />
        <path
          d="M20.8213 25.0509C20.3913 25.7209 19.6713 26.0909 18.9313 26.1009C18.9213 26.1009 18.9013 26.1009 18.9013 26.1009C18.9013 26.1009 18.7013 25.5609 18.7113 25.1009C18.7313 24.3509 18.8113 24.1309 18.8113 24.1309C18.8113 24.1309 18.8313 24.1309 18.8413 24.1309C20.1613 24.3909 20.9513 24.8109 20.9513 24.8109C20.9513 24.8109 20.9513 24.8209 20.9413 24.8309C20.9013 24.9009 20.8713 24.9709 20.8213 25.0409V25.0509Z"
          fill="#F1295E"
        />
        <path
          d="M19.1702 23.0707C19.1702 23.0707 19.4202 22.5707 20.0402 22.3407C20.1802 22.2907 20.4802 22.2207 20.4802 22.2207C20.4802 22.2207 20.5002 22.2407 20.5302 22.2607C20.9002 22.6407 21.1202 23.1407 21.1602 23.6507C21.1602 23.6607 21.1602 23.6807 21.1602 23.6807C21.1602 23.6807 20.8402 23.5307 20.4102 23.3907C20.0302 23.2607 19.5602 23.1307 19.2202 23.0707C19.1902 23.0707 19.1602 23.0707 19.1602 23.0707H19.1702Z"
          fill="#F1295E"
        />
      </svg>
    ),
    'ice-hockey': (
      <svg
        data-cy="sport-icehockey"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M23.3119 15.8506L17.2519 26.5006C17.2519 26.5006 17.2519 26.5306 17.2519 26.5406C17.1719 26.7006 16.6719 27.4906 14.5619 27.4806C13.7419 27.4806 12.8719 27.4806 12.0219 27.4806C9.62191 27.4806 7.44191 27.4506 7.44191 27.4506C7.44191 27.4506 7.32191 27.4306 7.14191 27.3906C6.49191 27.2106 5.08191 26.6006 6.00191 24.7006C6.67191 23.2506 7.40191 22.0806 7.40191 22.0806C7.40191 22.0806 8.13191 20.4706 9.97191 20.6406C10.3019 20.6806 10.6419 20.7106 10.9819 20.7406C12.2219 20.8606 13.4619 20.9606 14.1919 21.0106C14.1919 21.0106 15.0119 21.1606 15.8219 20.8906C16.3019 20.7206 16.7619 20.4106 17.0619 19.8306C17.5319 19.0506 18.9819 16.5106 20.3419 14.1406L23.3219 15.8406L23.3119 15.8506Z"
          fill="#FFB800"
        />
        <path
          d="M25.1028 12.6808L22.1328 10.9808L22.9728 9.50078C22.9728 9.50078 23.9028 7.80078 25.5828 8.84078C26.9128 9.67078 26.0028 11.0908 26.0028 11.0908L25.1028 12.6808Z"
          fill="#FFB800"
        />
        <path
          d="M21.6917 11.75L24.6617 13.45L23.7317 15.08L20.7617 13.39C21.0917 12.82 21.4017 12.27 21.6817 11.76L21.6917 11.75Z"
          fill="#FF4B81"
        />
        <path
          d="M15.8223 20.8902L12.0323 27.4802C9.63234 27.4802 7.45234 27.4502 7.45234 27.4502C7.45234 27.4502 7.33234 27.4302 7.15234 27.3902L10.9923 20.7402C12.2323 20.8602 13.4723 20.9602 14.2023 21.0102C14.2023 21.0102 15.0223 21.1602 15.8323 20.8902H15.8223Z"
          fill="#F2EEFF"
        />
        <path
          d="M16.4202 13.0008C16.4202 13.0008 16.4202 13.0808 16.3902 13.1108V13.1408C16.2802 13.4608 15.7602 13.7408 15.0102 13.9308C14.3402 14.1008 13.4902 14.2008 12.5502 14.2008C11.6102 14.2008 10.7802 14.1008 10.1102 13.9408C10.1102 13.9408 10.0902 13.9408 10.0702 13.9408C9.34016 13.7508 8.83016 13.4708 8.70016 13.1708C8.67016 13.1208 8.66016 13.0608 8.66016 13.0108C8.66016 12.3408 10.4002 11.8008 12.5402 11.8008C14.6802 11.8008 16.4102 12.3408 16.4102 13.0108L16.4202 13.0008Z"
          fill="#C0A6F7"
        />
        <path
          d="M16.4009 14.3516V16.0116C16.4009 16.1216 16.4009 16.2116 16.3709 16.3216C16.3709 16.3716 16.3309 16.4116 16.3209 16.4616C16.2509 16.5916 16.1509 16.7116 16.0509 16.7916C15.8709 16.9416 15.6809 17.0316 15.4809 17.1116C15.4109 17.1416 15.3309 17.1716 15.2509 17.1916C14.0909 17.5416 12.8109 17.6416 11.6209 17.5316C11.0209 17.4816 10.4309 17.3616 9.86094 17.1916C9.78094 17.1716 9.71094 17.1416 9.63094 17.1116C9.43094 17.0316 9.23094 16.9416 9.07094 16.7916C8.96094 16.7116 8.87094 16.6016 8.80094 16.4616C8.77094 16.4116 8.76094 16.3716 8.74094 16.3216C8.71094 16.2116 8.71094 16.1216 8.71094 16.0116V14.3516C9.93094 15.0516 12.0109 15.0916 12.5609 15.0916C13.1109 15.0916 15.1909 15.0516 16.4109 14.3516H16.4009Z"
          fill="#C0A6F7"
        />
        <path
          d="M25.1094 4.91906C25.1094 3.13906 26.4094 2.03906 27.7494 2.03906C29.3794 2.03906 30.1394 3.22906 30.1394 4.69906C30.1394 5.02906 30.0994 5.35906 30.0594 5.48906H26.9294C27.1094 6.14906 27.5894 6.36906 28.1994 6.36906C28.5694 6.36906 28.9194 6.25906 29.3194 6.03906L29.9394 7.15906C29.3494 7.57906 28.5594 7.79906 27.9394 7.79906C26.3394 7.79906 25.1094 6.74906 25.1094 4.91906ZM28.5394 4.25906C28.5394 3.83906 28.3594 3.46906 27.7894 3.46906C27.3694 3.46906 27.0194 3.70906 26.9094 4.25906H28.5394Z"
          fill="white"
        />
      </svg>
    ),
    'all-sports': (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'rgb(255, 206, 0)', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M16 4L18.5 12.5L27 15L18.5 17.5L16 26L13.5 17.5L5 15L13.5 12.5L16 4Z"
          fill="currentColor"
        />
      </svg>
    ),
    'esoccer': (
      <svg
        data-cy="sport-fifa-b"
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ fill: 'currentcolor', color: 'inherit', width: 'auto', height: iconSize }}
        className={className}
      >
        <path
          d="M23.9394 22.4414H21.7294L21.4894 23.1214L21.2294 23.8314L19.2794 29.2614H21.3394L21.5994 28.3514H23.9994L24.2794 29.2614H26.3994L23.9394 22.4414ZM21.9794 27.0314L22.7994 24.2014L23.6494 27.0314H21.9794ZM11.5094 22.4414V29.2614H13.6294V22.4414H11.5094ZM10.2894 23.9314L10.8494 22.4414H5.60938V29.2614H7.76937V26.8014H9.25938L9.83938 25.3114H7.76937V23.9314H10.2894Z"
          fill="#A37DF2"
        />
        <path
          d="M20.3277 22.4414L20.0377 23.2314L19.7677 23.9314H17.2477V25.3114H19.3277L18.7477 26.8014H17.2477V29.2614H15.0977V22.4414H20.3277Z"
          fill="#A37DF2"
        />
        <path
          d="M17.3394 7.89125L20.8194 10.0812L23.0594 10.1813C23.0594 10.1813 22.5794 9.61125 21.9194 9.08125C21.3394 8.61125 20.5994 8.18125 20.2294 7.99125C19.8794 7.81125 19.1894 7.51125 18.5094 7.33125C17.6694 7.11125 16.8594 7.03125 16.8594 7.03125L17.3394 7.91125V7.89125Z"
          fill="white"
        />
        <path
          d="M21.5312 11.1309V14.2209L23.7013 17.9309L25.3812 17.8509C25.3812 17.8509 25.5012 17.1409 25.4812 16.3109C25.4612 15.5409 25.3112 14.6709 25.2112 14.2409C25.1212 13.8709 24.9113 13.1509 24.6213 12.5309C24.2813 11.8109 23.8612 11.2009 23.8612 11.2009L21.5413 11.1309H21.5312Z"
          fill="white"
        />
        <path
          d="M22.8798 18.5313L21.6998 21.4213H16.9298L15.5898 19.3813L17.2498 15.8213L20.8498 15.1113L22.8798 18.5313Z"
          fill="white"
        />
        <path
          d="M13.9303 12.041L16.3403 15.481L14.7003 18.941L11.3003 19.371L9.07031 16.251L10.5303 12.731L13.9303 12.041Z"
          fill="white"
        />
        <path
          d="M16.4511 8.33094L14.1811 10.9609L10.3811 11.7609L8.87109 10.1309C8.87109 10.1309 9.38109 9.55094 10.0611 9.02094C10.7911 8.45094 11.7011 7.93094 12.1811 7.72094C12.5911 7.54094 13.4511 7.26094 14.2311 7.12094C15.0111 6.98094 15.7011 6.96094 15.7011 6.96094L16.4511 8.32094V8.33094Z"
          fill="white"
        />
        <path
          d="M10.3995 19.8606L10.3195 21.4206H7.81953C7.66953 21.1706 7.54953 20.9506 7.46953 20.7906C7.29953 20.4906 7.01953 19.8806 6.84953 19.2906C6.61953 18.4606 6.51953 17.6506 6.51953 17.6506L8.26953 16.8906L10.3995 19.8606Z"
          fill="white"
        />
        <path
          d="M17.3394 7.89125L20.8194 10.0812L23.0594 10.1813C23.0594 10.1813 22.5794 9.61125 21.9194 9.08125C21.3394 8.61125 20.5994 8.18125 20.2294 7.99125C19.8794 7.81125 19.1894 7.51125 18.5094 7.33125C17.6694 7.11125 16.8594 7.03125 16.8594 7.03125L17.3394 7.91125V7.89125Z"
          fill="#D9D2F5"
        />
        <path
          d="M21.5273 11.1309V14.2209L23.6973 17.9309L25.3773 17.8509C25.3773 17.8509 25.4973 17.1409 25.4773 16.3109C25.4573 15.5409 25.3073 14.6709 25.2073 14.2409C25.1173 13.8709 24.9073 13.1509 24.6173 12.5309C24.2773 11.8109 23.8573 11.2009 23.8573 11.2009L21.5373 11.1309H21.5273Z"
          fill="#D9D2F5"
        />
        <path
          d="M22.8806 18.5313L21.7006 21.4213H18.6406C19.2806 20.0613 19.6306 18.5513 19.6306 16.9513C19.6306 16.4113 19.5906 15.8913 19.5106 15.3713L20.8506 15.1113L22.8806 18.5313Z"
          fill="#D9D2F5"
        />
        <path
          d="M16.4489 8.32094L15.9289 8.92094C15.1689 8.27094 14.3089 7.72094 13.3789 7.31094C13.6489 7.24094 13.9489 7.17094 14.2289 7.12094C15.0089 6.97094 15.6989 6.96094 15.6989 6.96094L16.4489 8.32094Z"
          fill="#D9D2F5"
        />
        <path
          d="M24.0586 7.01086C24.0586 5.23086 25.3586 4.13086 26.6986 4.13086C28.3286 4.13086 29.0886 5.32086 29.0886 6.79086C29.0886 7.12086 29.0486 7.45086 29.0086 7.58086H25.8786C26.0586 8.24086 26.5386 8.46086 27.1486 8.46086C27.5186 8.46086 27.8686 8.35086 28.2686 8.13086L28.8886 9.25086C28.2986 9.67086 27.5086 9.89086 26.8886 9.89086C25.2886 9.89086 24.0586 8.84086 24.0586 7.01086ZM27.4886 6.35086C27.4886 5.93086 27.3086 5.56086 26.7386 5.56086C26.3186 5.56086 25.9686 5.80086 25.8586 6.35086H27.4886Z"
          fill="white"
        />
      </svg>
    ),
  };

  // Map sport IDs to icon keys
  const sportIconMap = {
    'all-sports': 'popular', // Use same icon as Popular
    'popular': 'popular',
    'soccer': 'soccer',
    'basketball': 'basketball',
    'tennis': 'tennis',
    'cricket': 'cricket',
    'ice-hockey': 'ice-hockey',
    'esoccer': 'esoccer',
    'table-tennis': 'table-tennis',
    'badminton': 'badminton',
    'handball': 'handball',
    'american-football': 'soccer', // Fallback
    'baseball': 'soccer', // Fallback
    'boxing': 'soccer', // Fallback
    'golf': 'soccer', // Fallback
    'racing': 'soccer', // Fallback
    'darts': 'soccer', // Fallback
    'snooker': 'soccer', // Fallback
    'rugby-league': 'soccer', // Fallback
    'rugby-union': 'soccer', // Fallback
  };

  const iconKey = sportIconMap[sportId] || 'soccer';
  const IconComponent = icons[iconKey] || icons['soccer'];

  return IconComponent;
};

export default SportsSVGIcons;
